import React from "react"
import Box from "./Box"

export default props => (
    <Box m={"auto"} px={10} width={["95%", "90%", "85%"]} py={40} {...props} />
)
